(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    	.controller('MailingCampaignsTagsController', mailingcampaigntags);

  mailingcampaigntags.$inject = ['$rootScope', 'FoundationApi', 'MailingTagService', 'ImportedFilesService', 'NotificationFactory', '$state', 'NotificationService', 'ngTableParams'];

  function mailingcampaigntags ($rootScope, FoundationApi, MailingTagService, ImportedFilesService, NotificationFactory, $state, NotificationService, ngTableParams) {
    var vm = this;

    var notifSet = new NotificationFactory({
      position: 'bottom-right'
    });

    var fileConfigs;

    vm.openForm = openForm;
    vm.closeFormModal = closeFormModal;
    vm.save = save;
    vm.content = [];
    vm.confirmDelete = confirmDelete;
    vm.removeTag = removeTag;
    vm.goToTheListing = goToTheListing;
    vm.loadCampaignTypes = loadCampaignTypes;
    vm.loadFileConfigs = loadFileConfigs;
    vm.tags = {}
    vm.editing = {};
    vm.deleting = {};
    vm.types = {};

    loadTags();
    loadCampaignTypes();

    function openForm (index) {
      vm.editing = (typeof index !== 'undefined') ? vm.tags.data[index] : {};
      loadFileConfigs();
      FoundationApi.publish('formModal', 'open');
    }

    function closeFormModal () {
      vm.editing = {};
      FoundationApi.publish('formModal', 'close');
    }

    function confirmDelete (index) {
      vm.deleting = vm.tags.data[index];
      FoundationApi.publish('confirmDeleteModal', 'open');
    }

    function removeTag (tag) {
      MailingTagService
        .delete({ id: tag.id })
        .$promise
        .then(function (obj) {
          FoundationApi.publish('confirmDeleteModal', 'close');

          loadTags();

          successHandler(obj, $rootScope.labels.tagRemoved);
        })
        .catch(function (error) {
          errorHandler(error, $rootScope.labels.errorRemoveTag);
        });
    }

    function goToTheListing () {
      $state.go('main.mailingcampaign', {});
    }

    function save () {
      if (!vm.editing.imported_files_id) {
        return;
      }

      if (typeof vm.editing.id !== 'undefined' && parseInt(vm.editing.id, 10) > 0) {
        MailingTagService
          .update(vm.editing)
          .$promise
          .then(function (result) {
            successHandler(result, $rootScope.labels.updatedTag);
            loadTags();
            FoundationApi.publish('formModal', 'close');
          })
          .catch(function (result) {
            errorHandler(result, $rootScope.labels.errorSaveTag);
          });
      } else {
        MailingTagService
          .create(vm.editing)
          .$promise
          .then(function (result) {
            successHandler(result, $rootScope.labels.savedTag);
            loadTags();
            FoundationApi.publish('formModal', 'close');
          })
          .catch(function (result) {
            errorHandler(result, $rootScope.labels.savedTag);
          });
      }
    }

    function loadTags () {
      vm.tagsTable = new ngTableParams({
        page: 1,
        count: 25
      }, {
        getData: function ($defer, params) {
          vm.content.page = params.url().page

          MailingTagService
            .listTags(vm.content)
            .$promise
            .then(function (data) {
              vm.tags = data.data;
              if (data.data) {
                $defer.resolve(data.data.data)
                params.total(data.data.total)
                vm.totalTags = data.data.total
              } else {
                vm.tagsTable = false
                errorHandler(error, vm.labels.errorLoadTags);
              }
            })
            .catch(function (error) {
              errorHandler(error, vm.labels.errorLoadTags);
            });
        }
      })
    }

    function loadFileConfigs () {
      ImportedFilesService
        .getCampaignFields({ imported_file_id: vm.editing.imported_files_id })
        .$promise
        .then(function (data) {
          vm.fields = data;
        })
        .catch(function (error) {
          errorHandler(error, vm.labels.errorLoadFieldInfo);
        });
    }

    function errorHandler (data, override_message) {
      var message = 'Erro. Tente novamente!';
      if (override_message) {
        message = override_message;
      }

      if (data && data.data && data.data.message) {
        message = data.data.message;
      }

      notifSet.addNotification({ title: $rootScope.labels.error, content: message, autoclose: '3000', color: 'alert' });
    }

    function successHandler (data, override_message) {
      var message = 'Os dados foram salvos com sucesso.';
      if (override_message) {
        message = override_message
      }

      if (data && data.data && data.data.message) {
        message = data.data.message;
      }

      notifSet.addNotification({ title: $rootScope.labels.success, content: message, autoclose: '3000', color: 'success' });
    }

    function loadCampaignTypes () {
      ImportedFilesService
        .loadCampaignTypes()
        .$promise
        .then(function (data) {
          vm.types = data;
        })
        .catch(function (error) {
          errorHandler(error, vm.labels.errorLoadCampTypes);
        });
    }
  }
})();
